import React from "react";

const TextArea = ({
  value,
  onChange,
  placeholder = "",
  label,
  showLabel = true,
  className = "",
  isDisabled = false,
  isRequired = false,
  maxLength,
  rows = 3,
  helperText,
  error,
  readOnly = false,
  ...props
}) => {
  return (
    <div className={className}>
      {showLabel && label && (
        <label className="block text-sm font-medium leading-6 text-gray-900">
          {label} {isRequired && <span className="text-red-500">*</span>}
        </label>
      )}
      <div className={showLabel && label ? "mt-2" : ""}>
        <textarea
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={isDisabled}
          readOnly={readOnly}
          maxLength={maxLength}
          rows={rows}
          className="block w-full rounded-md border-0 py-1.5 px-3 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-700 disabled:ring-gray-300 read-only:bg-gray-200 read-only:text-gray-700 read-only:ring-gray-300 read-only:cursor-default resize-y"
          {...props}
        />
        {helperText && (
          <p className="mt-1 text-xs text-gray-500">
            {helperText}
          </p>
        )}
        {error && (
          <p className="mt-1 text-xs text-red-600">
            {error}
          </p>
        )}
      </div>
    </div>
  );
};

export default TextArea; 